import { motion } from "framer-motion";
import { ASSETS } from "@/lib/brand";

const line = {
  initial: { y: "110%" },
  animate: (i) => ({
    y: 0,
    transition: { duration: 1.1, ease: [0.76, 0, 0.24, 1], delay: 0.3 + i * 0.12 },
  }),
};

export default function Hero() {
  return (
    <section data-testid="hero-section" className="relative h-screen w-full overflow-hidden bg-[#0A0A0A]">
      {/* Backdrop image with parallax */}
      <motion.div
        initial={{ scale: 1.15, opacity: 0 }}
        animate={{ scale: 1, opacity: 0.55 }}
        transition={{ duration: 2.2, ease: [0.22, 1, 0.36, 1] }}
        className="absolute inset-0"
      >
        <img
          src={ASSETS.heroHouse}
          alt=""
          className="w-full h-full object-cover"
          style={{ filter: "grayscale(60%) brightness(0.55) contrast(1.05)" }}
        />
        <div className="absolute inset-0 bg-gradient-to-b from-[#0A0A0A]/40 via-[#0A0A0A]/60 to-[#0A0A0A]" />
      </motion.div>

      {/* Corner runes removed per client */}

      {/* Kinetic headline */}
      <div className="relative z-10 h-full flex flex-col justify-end pb-28 md:pb-36 px-6 md:px-12 max-w-[1600px] mx-auto">
        <h1
          data-testid="hero-headline"
          className="font-serif text-[13vw] md:text-[9vw] leading-[0.9] tracking-[-0.03em] text-[#FAFAF9]"
        >
          <span className="block overflow-hidden">
            <motion.span variants={line} initial="initial" animate="animate" custom={0} className="block italic font-light">
              The <span className="text-[#CBBFAE]">Central Valley's</span>
            </motion.span>
          </span>
          <span className="block overflow-hidden">
            <motion.span variants={line} initial="initial" animate="animate" custom={1} className="block">
              real estate team.
            </motion.span>
          </span>
        </h1>

        <div className="mt-10 md:mt-14 grid grid-cols-1 md:grid-cols-12 gap-6 items-end">
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 1.5, duration: 1 }}
            className="md:col-span-8 text-white/70 text-base md:text-lg leading-relaxed whitespace-nowrap"
          >
            Serving the Central Valley with local roots and real results.
          </motion.p>
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 1.7, duration: 1 }}
            className="md:col-span-4 flex md:justify-end items-center gap-6"
          >
            <a
              data-testid="hero-cta-button"
              href="#listings"
              onClick={(e) => { e.preventDefault(); document.getElementById("listings")?.scrollIntoView({ behavior: "smooth" }); }}
              className="group inline-flex items-center gap-4 text-[12px] tracking-[0.3em] uppercase text-white/90 hover:text-[#CBBFAE] transition-colors"
            >
              <span className="h-px w-14 bg-[#CBBFAE] group-hover:w-24 transition-all duration-500" />
              View The Archive
            </a>
          </motion.div>
        </div>
      </div>

      {/* Scroll cue */}
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 0.5, y: [0, 8, 0] }}
        transition={{ delay: 2, y: { repeat: Infinity, duration: 2.2 } }}
        className="absolute bottom-6 left-1/2 -translate-x-1/2 text-white/50 text-[10px] tracking-[0.3em] uppercase"
      >
        scroll
      </motion.div>
    </section>
  );
}
